// import Product from '../containers/Product'
import ProductList from '../containers/ProductList'
import ProductDetail from '../containers/ProductDetail'

export default {
  path: '/product',
  name: 'Product',
  redirect: '/product/list',
  component: {
    render(c) { return c('router-view') }
  },
  children: [{
    path: 'list/',
    name: 'Product List',
    component: ProductList,
     meta: {
          label: 'ProductList'
        },
    props: true
  }, {
    path: 'detail',
    name: 'Product Detail',
    component: ProductDetail,
    props: true
  }, 

  // {
  //   path: 'myShop',
  //   name: 'My Shop',
  //   component: MyShop,
  // }

  ]
}



// WEBPACK FOOTER //
// ./src/Product/route/index.js